import appentis from "../../assets/img/appentis.jpg";
import appentisAdosse from "../../assets/img/appentis-adosse-2.jpg";
import appentisAutoporte from "../../assets/img/apppentis-autoporte-2.jpg";
import pergolasAdossee from "../../assets/img/pergola-adossee-1.jpg";
import pergolasAutoportee from "../../assets/img/pergola-autoportee-1.jpg";
import poolHouse from "../../assets/img/pool-house-4-pentes.jpg";
import poolHouseAutoportee from "../../assets/img/poolhouse-autoportee-1.jpg";
import abriVoiture from "../../assets/img/abri-voiture-autoporte.jpg";
import abriVoitureAdosse from "../../assets/img/abri-voiture-adosse-1.jpg";
import abriVoitureAutoporte from "../../assets/img/abri-voiture-autoporte-2.jpg";
import abriCollectif from "../../assets/img/abri-collectif.jpg";
import abriCollectifAdosse from "../../assets/img/abri-collectif-adosse-1.jpg";
import abriCollectifAutoporte from "../../assets/img/abri-collectif-autoporte-4.jpg";
import solutionDeco from "../../assets/img/solution-decorative.jpg";

export const abris = [

    {
        label: "Abri voiture",
        image: abriVoiture,
        types: [
            {
                label: "Adossé",
                image: abriVoitureAdosse,
            },
            {
                label: "Autoporté",
                image: abriVoitureAutoporte,
            },
        ],
    },
    {
        label: "Pergola",
        image: pergolasAdossee,
        pentes: 1,
        types: [
            {
                label: "Adossée",
                image: pergolasAdossee,
            },
            {
                label: "Autoportée",
                image: pergolasAutoportee,
            },
        ],
    },
    {
        label: "Pool house",
        image: poolHouse,
        types: [
            {
                label: "Adossé",
                image: poolHouseAutoportee,
            },
            {
                label: "Autoporté",
                image: poolHouse,
            },
        ],
    },
    {
        label: "Appentis & Auvent",
        image: appentis,
        types: [
            {
                label: "Adossé",
                image: appentisAdosse,
            },
            {
                label: "Autoporté",
                image: appentisAutoporte,
            },
        ],
    },
    {
        label: "Abri collectif",
        image: abriCollectif,
        types: [
            {
                label: "Adossé",
                image: abriCollectifAdosse,
            },
            {
                label: "Autoporté",
                image: abriCollectifAutoporte,
            },
        ],
    },
    {
        label: "Solution décorative",
        image: solutionDeco,
    },
];
